import {useLayoutEffect, useRef} from 'react';

export const DisableTableSelectionPlugin = () => {
  const draggingInCellRef = useRef(false);

  useLayoutEffect(() => {
    const inCell = (target: HTMLElement | null) => Boolean(target?.closest('td,th'));

    const onPointerDownCapture = (e: PointerEvent) => {
      const target = e.target as HTMLElement | null;

      if (e.button !== 0) return;

      // Reset each time we start a new pointer sequence
      draggingInCellRef.current = false;

      if (!target) return;
      if (!inCell(target)) return;

      draggingInCellRef.current = true;
      e.stopImmediatePropagation();
    };

    const onPointerMoveCapture = (e: PointerEvent) => {
      if (!draggingInCellRef.current) return;
      if ((e.buttons & 1) === 0) return;

      e.stopImmediatePropagation();
    };

    const onPointerUpCapture = () => {
      draggingInCellRef.current = false;
    };

    document.addEventListener('pointerdown', onPointerDownCapture, true);
    document.addEventListener('pointermove', onPointerMoveCapture, true);
    document.addEventListener('pointerup', onPointerUpCapture, true);
    document.addEventListener('pointercancel', onPointerUpCapture, true);

    return () => {
      document.removeEventListener('pointerdown', onPointerDownCapture, true);
      document.removeEventListener('pointermove', onPointerMoveCapture, true);
      document.removeEventListener('pointerup', onPointerUpCapture, true);
      document.removeEventListener('pointercancel', onPointerUpCapture, true);
    };
  }, []);

  return null;
};
